import { ExcelFileIcon, PdfFileIcon, PowerPointFileIcon, RandomFileTypeIcon, WordFileIcon } from '@synergy/theme-next';
import { ReactElement } from 'react';

export interface FileTypeIconProps {
    type: string;
}

export const FileTypeIcon = ({ type }: { type?: string }): ReactElement => {
    switch (type) {
        case 'application/pdf':
            return <PdfFileIcon />;

        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/msword':
            return <WordFileIcon />;

        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.ms-excel':
            return <ExcelFileIcon />;

        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.ms-powerpoint':
            return <PowerPointFileIcon />;

        default:
            return <RandomFileTypeIcon />;
    }
};
